"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _Box = _interopRequireDefault(require("../Containers/Box"));
var _GhostButton = _interopRequireDefault(require("../Buttons/GhostButton"));
var _Icon = _interopRequireDefault(require("../Icons/Icon"));
var _ModalCloseButton = _interopRequireDefault(require("../Modals/ModalCloseButton"));
var _Text = _interopRequireDefault(require("../Typography/Text"));
var _helpers = require("../helpers");
var _mixins = require("../mixins");
var _excluded = ["status", "withCloseButton", "close", "title", "message", "large", "withBottomButtons", "variant", "leftAction", "rightAction", "children", "automationHook"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var propTypes = {
  /**  A status for the notification. will determine colors and icon. */
  status: _propTypes["default"].oneOf(["success", "warning", "error"]),
  /** Add a close button in the corner. */
  withCloseButton: _propTypes["default"].bool,
  /** Callback for the close button. Should remove the notification. */
  close: _propTypes["default"].func,
  /** Wether the notification should be larger. */
  large: _propTypes["default"].bool,
  /** Defaults to "floating". Influences the style of the notification card. */
  variant: _propTypes["default"].oneOf(["floating", "inline"]),
  /** Main text on the notification. */
  title: _propTypes["default"].string,
  /** Lighter smaller text on the notification. */
  message: _propTypes["default"].string,
  /** When true, the bottom buttons are added. */
  withBottomButtons: _propTypes["default"].bool,
  /** Action to perform when left side button is clicked. */
  leftAction: _propTypes["default"].func,
  /** Action to perform when right side button is clicked. */
  rightAction: _propTypes["default"].func,
  /** Other content to be displayed after the message and above the buttons(if there are any). */
  children: _propTypes["default"].node,
  /** Hook used for automation testing */
  automationHook: _propTypes["default"].string
};
var Card = _styledComponents["default"].div.attrs(function (props) {
  return _objectSpread({}, (0, _helpers.getDataHookProp)(props.automationHook));
}).withConfig({
  displayName: "Notification__Card",
  componentId: "sc-1iv1kpd-0"
})(["position:relative;width:100%;overflow:hidden;border-radius:", ";", ";&::before{content:\"\";position:absolute;top:0;left:0;height:100%;width:0;border-left:4px solid ", ";}", " ", " ", ""], function (props) {
  return props.theme.borderRadius.m;
}, _mixins.marginMixin, function (props) {
  return (0, _helpers.getColor)(props, "status", "success");
}, function (props) {
  return props.large ? (0, _styledComponents.css)(["padding:", ";padding-left:", ";"], props.theme.spaces.m, function (props) {
    return props.theme.spaces.base;
  }) : (0, _styledComponents.css)(["padding:", ";padding-left:", ";"], props.theme.spaces.base, props.theme.spaces.s);
}, function (props) {
  return props.variant === "floating" && (0, _styledComponents.css)(["background-color:", ";box-shadow:", ";"], props.theme.colors.backgroundPrimary, props.theme.boxShadow.notification);
}, function (props) {
  return props.variant === "inline" && (0, _styledComponents.css)(["background-color:", ";"], props.theme.colors.backgroundSecondary);
});
var TextContent = (0, _styledComponents["default"])(_Box["default"]).attrs(function () {
  return {
    d: "flex",
    direction: "column",
    gap: "xxs"
  };
}).withConfig({
  displayName: "Notification__TextContent",
  componentId: "sc-1iv1kpd-1"
})(["", ";"], function (props) {
  return props.withCloseButton && (0, _styledComponents.css)(["> *:first-child{padding-right:", ";}"], function (props) {
    return props.theme.spaces.m;
  });
});
var getStatusIcon = function getStatusIcon(status) {
  switch (status) {
    case "error":
      return "AlertDiamondFill";
    case "warning":
      return "AlertTriangleFill";
    default:
      return "CheckCircleFill";
  }
};
var Title = _styledComponents["default"].h3.withConfig({
  displayName: "Notification__Title",
  componentId: "sc-1iv1kpd-2"
})(["line-height:1.1;"]);
var Notification = function Notification(_ref) {
  var _ref$status = _ref.status,
    status = _ref$status === void 0 ? "success" : _ref$status,
    _ref$withCloseButton = _ref.withCloseButton,
    withCloseButton = _ref$withCloseButton === void 0 ? true : _ref$withCloseButton,
    close = _ref.close,
    title = _ref.title,
    message = _ref.message,
    _ref$large = _ref.large,
    large = _ref$large === void 0 ? false : _ref$large,
    _ref$withBottomButton = _ref.withBottomButtons,
    withBottomButtons = _ref$withBottomButton === void 0 ? true : _ref$withBottomButton,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "floating" : _ref$variant,
    leftAction = _ref.leftAction,
    rightAction = _ref.rightAction,
    children = _ref.children,
    automationHook = _ref.automationHook,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Card, _extends({
    large: large,
    status: status,
    variant: variant,
    automationHook: (0, _automationHooks.getHook)(automationHook, "card")
  }, rest), withCloseButton && /*#__PURE__*/_react["default"].createElement(_ModalCloseButton["default"], {
    iconSize: "s",
    onClick: close,
    automationHook: (0, _automationHooks.getHook)(automationHook, "close-button")
  }), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    d: "flex",
    gap: "xs"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: getStatusIcon(status),
    color: status
  }), /*#__PURE__*/_react["default"].createElement(TextContent, {
    withCloseButton: withCloseButton
  }, title && /*#__PURE__*/_react["default"].createElement(Title, {
    automationHook: (0, _automationHooks.getHook)(automationHook, "title")
  }, title), message && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: "textSecondary",
    withNewLines: true,
    fontSize: large ? "base" : undefined,
    automationHook: (0, _automationHooks.getHook)(automationHook, "message")
  }, message), children)), withBottomButtons && /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    d: "flex",
    justifyContent: "flex-end",
    gap: "xs",
    mT: "xs"
  }, /*#__PURE__*/_react["default"].createElement(_GhostButton["default"], {
    onClick: leftAction,
    pV: "none",
    automationHook: (0, _automationHooks.getHook)(automationHook, "left-action-button")
  }, status === "error" ? "Resolve" : "Dismiss"), /*#__PURE__*/_react["default"].createElement(_GhostButton["default"], {
    onClick: rightAction,
    pV: "none",
    automationHook: (0, _automationHooks.getHook)(automationHook, "right-action-button")
  }, "OK")));
};
Notification.propTypes = propTypes;
var _default = Notification;
exports["default"] = _default;